import { getFileAnswerMarkdown } from '@app/src/pages/Questionnaire/utils'
import type { ResponseItem } from '@app/src/types/resourceExplorer'
import { Typography } from '@mui/material'
import React from 'react'
import Markdown from './Markdown'
import RenderFileDownload from './RenderFileDownload'

type FileAnswerContentProps = {
  item: ResponseItem
  showExpiresAtText?: boolean
}

/**
 * Renders file answer content for file-type questions.
 * Assumes the caller has already verified this is a file question type.
 */
const FileAnswerContent: React.FC<FileAnswerContentProps> = ({ item, showExpiresAtText = false }) => {
  const uploadRef = item.uploadReferences?.[0]
  if (uploadRef && uploadRef.originalFileName && uploadRef.id != null) {
    return (
      <RenderFileDownload
        fileName={uploadRef.originalFileName}
        id={uploadRef.id}
        expiresAt={item.expiresAt}
        showExpiresAtText={showExpiresAtText}
      />
    )
  }

  const markdown = getFileAnswerMarkdown(item)
  if (markdown) {
    return (
      <Typography>
        <Markdown>{markdown}</Markdown>
      </Typography>
    )
  }

  return <Typography>{item.answer ?? '-'}</Typography>
}

export default FileAnswerContent
